var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"upload-modal",attrs:{"name":"upload-modal","height":"auto","width":"350px","adaptive":true}},[_c('upload-status')],1)}
var staticRenderFns = []

export { render, staticRenderFns }